export default `<h3>Уход</h3>
<ul>
  <li>Машинная или ручная стирка при температуре <b>не выше 30 градусов</b></li>
  <li>При стирке изделия следует <b>выворачивать наизнанку</b></li>
  <li>Использовать ручной (рекомендуется) или мягкий отжим (<b>не более 400 оборотов</b>)</li>
  <li>Не использовать хлоросодержащие отбеливатели</li>
  <li>Не гладить по изображению</li>
</ul>`;
